import mod from "../../../util/mod";
import range from "../../../util/range";
export var getMonths = function getMonths(date) {
  return range(0, 12).map(function (month) {
    return new Date(date.getFullYear(), month, 1);
  });
};
export var getYears = function getYears(date) {
  var centerYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var now = new Date();
  var currentYear = date.getFullYear();
  var month = date.getMonth();
  var end = currentYear + 1;

  if (centerYears) {
    end += 6;
  } else {
    end += mod(now.getFullYear() - currentYear, 12);
  }

  var start = end - 12;
  return range(start, end).map(function (year) {
    return new Date(year, month, 1);
  });
};